import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, EDIT_LIGHT_LOGO, EDIT_DARK_LOGO, EDIT_COMPANY_SEAL } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing PUT request and response contract. */
export function editLightLogo(formData1, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_LIGHT_LOGO}`, formData1, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editDarkLogo(formData1, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_DARK_LOGO}`, formData1, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editCompanySeal(formData1, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_COMPANY_SEAL}`, formData1, configReq(token));
}
